import {Component, Inject} from '@angular/core';
import {kanUsersService} from "../../../services/services/users";
import {DateAdapter, MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {Dog} from "../../../../classes/dog";
import {kanMembershipService} from "../../../services/services/membership";
import {MembershipType} from "../../../../classes/membershipType";
import {kanDogsService} from "../../../services/services/dogs";
import {User} from "../../../../classes/user";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs/Observable";
import {getDateString} from "../../../../utils/dateFormat";

@Component({
    selector: 'kan-dog-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanDogDialog {
    public searchText: string = '';
    public dog: Dog = new Dog();
    public users: User[];
    public filteredUsers: User[];
    public selectedOwner: any;
    public selectedMembershipType: MembershipType;
    public membershipDate: string = getDateString(new Date());
    public membershipRenewalDate: string = getDateString(new Date());
    public birthday: string = '';
    public deathDate: string = '';
    public ownerCtrl: FormControl = new FormControl();
    public genders: string[] = ['MALE', 'FEMALE'];
    public membershipTypes: MembershipType[] = [];
    public hasUser: boolean = false;
    public isNew: boolean = true;

    public generalDataForm: FormGroup;
    public userForm: FormGroup;
    public membershipForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanDogDialog>,
                private adapter: DateAdapter<any>,
                private formBuilder: FormBuilder,
                private dogService: kanDogsService,
                private usersService: kanUsersService,
                private membershipService: kanMembershipService,
                @Inject(MAT_DIALOG_DATA) private data: any) {
        if (this.data && this.data.user) {
            this.selectedOwner = this.data.user;
            this.hasUser = true;
        }

        if (this.data && this.data.dog) {
            this.dog = JSON.parse(JSON.stringify(this.data.dog));
            this.dog.birthday = this.dog.birthday ? new Date(this.dog.birthday) : null;
            this.dog.deathDate = this.dog.deathDate ? new Date(this.dog.deathDate) : null;
            this.dog.membershipDate = this.dog.membershipDate ? new Date(this.dog.membershipDate) : null;
            this.dog.membershipRenewalDate = this.dog.membershipRenewalDate ? new Date(this.dog.membershipRenewalDate) : null;
            this.birthday = getDateString(this.dog.birthday);
            this.deathDate = getDateString(this.dog.deathDate);
            this.membershipDate = getDateString(this.dog.membershipDate);
            this.membershipRenewalDate = getDateString(this.dog.membershipRenewalDate);
            this.selectedMembershipType = this.dog.membershipType;
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.adapter.setLocale('es');

        this.usersService.getUsers({
            where: {
                role: 'USER',
                active: true
            }
        })
            .then((users: User[]) => {
                this.users = users;
                this.filterUsers(null);
            })
            .catch((error: any) => {
                console.log(error);
            });

        this.membershipService.getTypes()
            .then((membershipTypes: MembershipType[]) => {
                this.membershipTypes = membershipTypes;
            })
            .catch((error: any) => {
                console.log(error);
            });

        this.userForm = this.formBuilder.group({
            owner: new FormControl(this.selectedOwner, [Validators.required]),
        });

        this.generalDataForm = this.formBuilder.group({
            name: new FormControl(this.dog.name, [Validators.required]),
            birthday: new FormControl(this.birthday),
            deathDate: new FormControl(this.deathDate),
            race: new FormControl(this.dog.race),
            gender: new FormControl(this.dog.gender, [Validators.required]),
            sterilized: new FormControl(this.dog.sterilized)
        });

        this.membershipForm = this.formBuilder.group({
            membershipActive: new FormControl(this.dog.membershipActive),
            membershipType: new FormControl(this.selectedMembershipType),
            membershipDate: new FormControl(this.dog.membershipDate),
            membershipRenewalDate: new FormControl(this.dog.membershipRenewalDate)
        });
    }

    public filterUsers(event) {
        if (!this.users) {
            this.filteredUsers = [];
        } else if (typeof this.searchText === 'string' || !this.searchText) {
            this.filteredUsers = this.users.filter((user) => {
                let arr = (this.searchText || '').split(' ');
                let found = true;
                arr.forEach((item) => {
                    if (item) {
                        found = found &&
                            (user.name.toLowerCase().indexOf(item.toLowerCase()) > -1 ||
                                (user.surname ? user.surname.toLowerCase().indexOf(item.toLowerCase()) > -1 : false));
                    }
                });
                return found;
            }).slice(0, 30);
        }
    }

    public userSelected(event) {
        this.selectedOwner = event.option.value;
        this.searchText = (this.selectedOwner.surname ? this.selectedOwner.surname + ', ' : '') + this.selectedOwner.name
    }

    public onOwnerBlur(event: any) {
        setTimeout(() => {
            if(this.selectedOwner) {
                this.searchText = (this.selectedOwner.surname ? this.selectedOwner.surname + ', ' : '') + this.selectedOwner.name
            }
        }, 100);
    }

    public reserMembershipActive(event) {
        this.membershipForm.controls.membershipType.setErrors(null);
    }

    public addDog(event): void {
        if (this.selectedOwner) {
            this.dog.ownerId = this.selectedOwner.id;
        }

        if (this.dog.membershipActive) {
            this.dog.membershipTypeId = this.selectedMembershipType.id;
            this.dog.membershipDate = new Date(this.membershipDate);
            this.dog.membershipRenewalDate = new Date(this.membershipRenewalDate);
        }

        if (this.birthday) {
            this.dog.birthday = new Date(this.birthday);
        } else {
            this.dog.birthday = null;
        }

        if (this.deathDate) {
            this.dog.deathDate = new Date(this.deathDate);
        } else {
            this.dog.deathDate = null;
        }

        this.dog.ownerName = this.selectedOwner.name + ' ' + (this.selectedOwner.surname ? this.selectedOwner.surname : '');

        this.dogService.addDog(this.dog)
            .then((data) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateDog(event: any): void {
        if (this.selectedOwner) {
            this.dog.ownerId = this.selectedOwner.id;
        }

        if (this.birthday) {
            this.dog.birthday = new Date(this.birthday);
        } else {
            this.dog.birthday = null;
        }

        if (this.deathDate) {
            this.dog.deathDate = new Date(this.deathDate);
        } else {
            this.dog.deathDate = null;
        }

        this.dogService.updateDog(this.dog)
            .then((data) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/dog-dialog/component.ts